import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { PositionService } from '../position.service';
import { Position } from '../position';
import { Router } from '@angular/router';
 
@Component({
  selector: 'app-position-crud',
  templateUrl: './position-crud.component.html',
  styleUrls: ['./position-crud.component.css'],
  providers: [PositionService]
  // encapsulation: ViewEncapsulation.None
})
export class PositionCrudComponent implements OnInit {

  msgs: Message[] = [];
  positions: Position;
 	button_caption: string ="Сохранить";
 	button_icon:string ="fa fa-save";
  panel_header_caption: string = "Регистрация должности";
  loading: boolean = false;
  id: any = null;  

  constructor(
              private location: Location,
              private activatedRoute: ActivatedRoute,
              private positionService: PositionService,
              private router: Router
              ) { 
  
              activatedRoute.params.subscribe(params=>{this.id=params['id']});

              if(this.id){
                     this.panel_header_caption = "Редактирования должности";
                     this.loading=true;  
                     this.positionService.getPositionById(this.id).subscribe(reponse=>{this.positions=reponse['data'];this.loading=false;});  
                     this.button_caption="Редактировать";
                     this.button_icon="fa fa-edit";
              }  
  }

  ngOnInit() {
        this.positions={
            id: "",
            name: "",
            available: true
        };
  }

  backClicked() {
        this.location.back();
  }

  crud(form: NgForm){
      if(!this.id){
             this.loading=true;  
             this.positionService.createPosition(form.value)
             .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/position',form.value.name]);}
                  , (error)=>{this.loading=false;let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});

         }else{
             this.loading=true;   
             this.positionService.updatePosition(form.value,this.id)
             .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/position',form.value.name]);}
                  , (error)=>{this.loading=false;let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
         }
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/positions/position-crud/position-crud.component.ts